var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArt1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2313 1.44469L1.89302 40H0.191406L8.61435 1.44469H10.2313Z",
    fill: "#D4A85E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2308 1.44469L1.89256 40H0.964844L9.56658 1.44469H10.2308Z",
    fill: "#CB8626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4565 6.74368e-05V38.3862H9.88965V6.74368e-05H11.4565Z",
    fill: "#CB8626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9079 6.74368e-05V38.3862H9.88965V6.74368e-05H10.9079",
    fill: "#D4A85E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3179 1.44469L19.656 40H21.3576L12.9344 1.44469H11.3179Z",
    fill: "#D4A85E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3179 1.44469L19.656 40H20.5835L11.982 1.44469H11.3179",
    fill: "#CB8626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3491 3.70388V24.9683H0V3.70388H21.3491Z",
    fill: "#E7E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3492 3.70388V24.9683H11.231V14.3361V3.70388H21.3492Z",
    fill: "#DFE0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23164 3.70388V24.9683H2.05859V3.70388H8.23164",
    fill: "#F7F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1492 25.169C20.1492 25.2694 20.1367 25.3665 20.1087 25.4606C19.9833 25.9337 19.5477 26.2847 19.0338 26.2847H2.31633C1.80226 26.2847 1.3667 25.9337 1.24149 25.4606C1.2132 25.3665 1.20068 25.2694 1.20068 25.169C1.20068 24.9842 1.25092 24.8086 1.33229 24.6551H20.0177C20.0992 24.8086 20.1492 24.9842 20.1492 25.169",
    fill: "#D4A85E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1079 25.4604C19.9824 25.9335 19.547 26.2844 19.0331 26.2844H2.31559C1.80151 26.2844 1.36593 25.9335 1.24072 25.4604H20.1079Z",
    fill: "#CB8626"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt1);
export default __webpack_public_path__ + "static/media/art1.6ab690ea6034262b49fdb4aebcc95b61.svg";
export { ForwardRef as ReactComponent };